<template>
  <div v-bem>
    <ul v-bem:menu>
      <li>
        <a v-bem:link :href="accountLogoutUrl">{{ t('Abmelden') }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AccountMenu',
  computed: mapState('pageHeader', ['accountLogoutUrl']),
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.account-menu {
  width: 100%;

  @include utils.bs-media-breakpoint-up(md) {
    padding: utils.f-rem-calc(6) utils.f-rem-calc(12) 0;
  }

  @at-root #{&}__menu {
    list-style: none;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid map.get(utils.$v-colors, acc-gray-040);

    @include utils.bs-media-breakpoint-up(md) {
      font-size: utils.f-convert-to-rem(14);
      line-height: 1em;
      border-bottom: none;
    }
  }

  @at-root #{&}__link {
    display: block;
    padding: utils.f-rem-calc(14) 0;
    color: map.get(utils.$v-colors, acc-gray-080);
    text-decoration: none;
    border-top: 1px solid map.get(utils.$v-colors, acc-gray-040);
    transition: all 320ms;

    @include utils.bs-media-breakpoint-up(md) {
      color: map.get(utils.$v-colors, acc-black);
    }

    &:hover {
      color: map.get(utils.$v-colors, acc-orange);
    }
  }
}
</style>
